import type React from 'react';

import { CheckRounded, ClearRounded } from '@mui/icons-material';
import { Handle, Position } from '@xyflow/react';

/**
 * TrueFalseHandles is a component that renders two handles for a true/false condition.
 * It is used in the flowchart to connect the nodes that may accept or reject a condition, like CalendarNode.
 * @returns {React.ReactElement}
 */
const TrueFalseHandles = (): React.ReactElement => {
  return (
    <>
      <Handle type='source' position={Position.Right} style={{ top: 19 }} id='true_connection'>
        <CheckRounded color='success' sx={{ marginTop: '6px', marginLeft: '-1px', width: 12, height: 12 }} />
      </Handle>
      <Handle type='source' position={Position.Right} style={{ top: 46 }} id='false_connection'>
        <ClearRounded color='error' sx={{ marginTop: '8px', marginLeft: '-2px', width: 12, height: 12 }} />
      </Handle>
    </>
  );
};

export default TrueFalseHandles;
